import { BaseApi } from "./BaseApi";
import globalMU from "../../../globalMU";
import { IColuna } from "app/types/IColuna";
import {IOrcamento} from "../../types/IOrcamento";
import { FiltrosListarTemplateSeguranca, RespostaModalImprimir } from "app/types/modalImprimir/RespostaModalImprimir";
import { anexosEnviar } from "app/types/modalImprimir/ModalEnviarEmail";

export class SegurancaApi extends BaseApi {
    constructor() {
        super();

    }

    url(path): string {
        return `${globalMU.restUrl()}/api/seguranca/${path}`
    }

    async atualizarColunasGridOrcamento(colunas:IColuna[], nomeGrid: "ITENS_ORCAMENTO" | "CONSULTAR_ITENS_ORCAMENTO" ) : Promise<void> {

        const resposta = await this.api.post(this.url('grid/atualizar'), {
            codigoUsuario: globalMU.userIdForGrid(),
            modulo: "Orcamento",
            nomeGrid,
            token: globalMU.token(),
            colunas
        })
        return resposta.data
    }

    async atualizarColunasCliente(colunas:IColuna[], nomeGrid: "PESQUISAR_CLIENTE_ORCAMENTO" ) : Promise<void> {

        const resposta = await this.api.post(this.url('grid/atualizar'), {
            codigoUsuario: globalMU.userIdForGrid(),
            modulo: "Orcamento",
            nomeGrid,
            token: globalMU.token(),
            colunas
        })
        return resposta.data
    }
    
    async atualizarGrid(dados: SegurancaApi.AtualizarGridRequisicao) : Promise<SegurancaApi.AtualizarGridResposta> {
        return (await this.api.post(this.url('grid/atualizar'), globalMU.converterNomesPropriedadesParaPrimeiraLetraLowerCase(dados))).data
    }

    async atualizarGridEhEstoque(dados: SegurancaApi.AtualizarGridRequisicao) : Promise<SegurancaApi.AtualizarGridResposta> {
        return (await this.api.post(this.url('grid/atualizarGridEstoque'), globalMU.converterNomesPropriedadesParaPrimeiraLetraLowerCase(dados))).data
    }

    async criarOrcamento(orcamento: IOrcamento) : Promise<IOrcamento> {

        const resposta = await this.api.post(`${globalMU.restUrl()}/api/venda/orcamento/criar?token=${globalMU.token()}`, orcamento)
        return resposta.data
    }

    async obterDadosGridOrcamento() : Promise<SegurancaApi_ObterDadosGrids_Output> {
        const resposta = await this.api.get(this.url('grid/obter'), {
            params: {
                codigoUsuario: globalMU.userIdForGrid(),
                modulo: "Orcamento",
                nomeGrid: "ITENS_ORCAMENTO",
                token: globalMU.token(),
            }
        })

        return resposta.data
    }

    async obterDadosGridOrcamentoEstoque() : Promise<IColuna[]> {
        const resposta = await this.api.get(this.url('grid/obterEstoque'), {
            params: {
                codigoUsuario: globalMU.userIdForGrid(),
                modulo: "Orcamento",
                nomeGrid: "ITENS_ORCAMENTO",
                token: globalMU.token(),
            }
        })

        return resposta.data
    }

    async atualizarColunasGrid(colunas:IColuna[], nomeGrid: string) : Promise<void> {

        const resposta = await this.api.post(this.url('grid/atualizar'), {
            codigoUsuario: globalMU.userIdForGrid(),
            modulo: "Orcamento",
            nomeGrid,
            token: globalMU.token(),
            colunas
        })
        return resposta.data
    }

    async obterDadosGridConsultaItens() : Promise<SegurancaApi_ObterDadosGrids_Output> {
        const resposta = await this.api.get(this.url('grid/obter'), {
            params: {
                codigoUsuario: globalMU.userIdForGrid(),
                modulo: "Orcamento",
                nomeGrid: "CONSULTAR_ITENS_ORCAMENTO",
                token: globalMU.token(),
            }
        })

        return resposta.data
    }

    async obterDadosGridConsultaItensEstoque() : Promise<IColuna[]> {
        const resposta = await this.api.get(this.url('grid/obterEstoque'), {
            params: {
                codigoUsuario: globalMU.userIdForGrid(),
                modulo: "Orcamento",
                nomeGrid: "CONSULTAR_ITENS_ORCAMENTO",
                token: globalMU.token(),
            }
        })

        return resposta.data
    }

    async listar(filtros: FiltrosListarTemplateSeguranca): Promise<RespostaModalImprimir[]> {
        const resposta = 
        await this.api.get
        (
            this.url
            (
                'template/listar?token='+filtros.token + 
                '&codigoUsuario='+filtros.codigoUsuario + 
                '&siglaFuncionalidade='+filtros.siglaFuncionalidade +
                '&siglaAcao='+filtros.siglaAcao+
                '&codigoFilial='+filtros?.codigoFilial
            ));

        return resposta.data
      }

    async obterDadosGrid(modulo: string, nomeGrid: string): Promise<SegurancaApi.ObterDadosGridResposta> {
        // 491123 — um catch local aqui engolia QUALQUER erro (inclusive sessão expirada),
        // mostrava só um toast de info e retornava null. O chamador (ex:
        // PaginaPesquisaProdutoContainer.tsx) seguia lendo `resposta.Colunas` de um valor
        // null, lançando um TypeError novo e sem relação — capturado por
        // tratamentoErroPadrao.ts como "Houve um erro desconhecido", mascarando a mensagem
        // real (confirmado com sessão expirada de verdade via
        // playwright-tests/investigacaoSessaoExpiradaReal_PA_491123.js). Deixando o erro
        // propagar, o interceptor de this.api (BaseApi.ts) já trata sessão expirada
        // corretamente, e qualquer outro erro chega ao catch do chamador intacto.
        const resposta = (await this.api.get(this.url(`grid/obter`), {
            params: {
                codigoUsuario: globalMU.userIdForGrid(),
                modulo,
                nomeGrid,
                token: globalMU.token(),
            }
        })).data

        if (resposta != null && resposta.TamanhoFonte < 2) {
            resposta.TamanhoFonte = 2
        }
        return resposta
    }

    async obterUsuarioPorToken(): Promise<Usuario> {

        const resposta = await this.api.get(this.url('obterUsuarioPorToken'), {
            params: {
                token: globalMU.token(),
            }
        })
        return resposta.data
    }

    async obterDadosGridPesquisaCliente(): Promise<SegurancaApi.ObterDadosGridResposta> {
        const resposta = await this.api.get(this.url('grid/obter'), {
            params: {
                codigoUsuario: globalMU.userIdForGrid(),
                modulo: "Orcamento",
                nomeGrid: "PESQUISAR_CLIENTE_ORCAMENTO",
                token: globalMU.token(),
            }
        })

        return resposta.data
    }

    async enviarAnexos(token:string,binario): Promise<anexosEnviar[]> {
        const resposta = 
        await this.api.post(globalMU.restUrl()+'/api/comum/email/anexos?token='+token,binario,{headers: { "Content-Type": "multipart/form-data" }});
        return resposta.data
    }
}

export namespace SegurancaApi {
    export type ObterDadosGridResposta = {
        Codigo?: number
        Colunas?: {
            Codigo?: number
            Nome?: string
            Permitido?: boolean
            Selecionada?: boolean
            UserMessage?: any
            Transforming?: boolean
        }[]
        Modulo?: string
        Nome?: string
        TamanhoFonte?: number
        UserMessage?: any
        Transforming?: boolean
    }
}

export namespace SegurancaApi {
    export type AtualizarGridRequisicao = {
        Token?: string
        CodigoUsuario?: number
        Modulo?: string
        NomeGrid?: string
        Colunas?: {
            Nome?: string
            Selecionada?: boolean
            Grid?: string
            Codigo?: number
            Permitido?: boolean

        }[]
    }

    export type AtualizarGridResposta = {
        Codigo?: number
        Modulo?: string
        Nome?: string
        TamanhoFonte?: number
        UserMessage?: any
        Transforming?: boolean
        Colunas?: {
            Codigo?: number
            Nome?: string
            Permitido?: boolean
            Selecionada?: boolean
            UserMessage?: any
            Transforming?: boolean
        }[]
    }
}

export type SegurancaApi_ObterDadosGrids_Output = {
    Codigo: number,
    Colunas: IColuna[],
    Modulo: "Orcamento",
    Nome: "ITENS_ORCAMENTO",
    TamanhoFonte: number
}

export type Usuario = {
    Codigo?: number,
    Excluido?: boolean,
    expandido?: boolean,
    Grupos?: any,
    Nome?: string,
    novo?: boolean,
    selecionado?: boolean,
    Externo?: boolean,
    UserMessage?: string,
    Transforming?: boolean
}



